import React, { Component } from 'react';
import Toast from '../../components/Toast/Toast';
import Inner from './Inner';

class Wrapper extends Component {
    state = {
         showToast: false,
         toastInner: null
    }

    showToast = (msg) => {
        console.log("Showing toast", this, this.state);
        this.setState({showToast: true, toastInner: msg}, () => {
            console.log(this, this.state);
        });
    };

    hideToast = () => {
        console.log("Hiding toast", this.state);
        this.setState({showToast: false});
    }


    render(){
        return (
            <>
            {this.state.showToast ? 
            <Toast onHide={this.hideToast} >
                {this.state.toastInner}
            </Toast> : null }
            <Inner {...this.props} toast={this.showToast} />
            </>
        )
    }
    
}
export default Wrapper;